angular.module('ihestiaIkomunikator.notificationBar', [

]);
